import React from "react";
import { Typography } from "@plum-xoxo/admin-dsm";
import { app_path } from "config";

const DiwaliGifting = (props) => {

  return (
    <></>
    // <a
    //   href={`/${app_path}/holiday-gifting/`}
    //   rel="noreferrer"
    //   className="mr-28"
    // >
    //   <Typography.LabelText
    //     id={`bulk-gifting-title`}
    //     className="cursor-pointer"
    //     color="dark"
    //     shade="c200"
    //     component="div"
    //   >
    //     Diwali Gifting <img src="/admin/img/svg-icons/Sparkle.svg" />
    //   </Typography.LabelText>
    // </a>
  );
};

export default DiwaliGifting;
